export const ABT_YOURSELF = 'about-yourself';
export const METHOD_NAME = 'sendData';
export const LQ_RESPONSE = 'LQResponse';
export const SWEETNER_CONTROL_TREAT_GROUP = [
  '|FWA_Sweetener_T_Deal_P',
  '|FWA_Sweetener_T_Deal',
  '|FWA_Sweetener_C_Deal_P',
  '|FWA_Sweetener_C_Deal',
  'FWA_Sweetener_T_Deal_P',
  'FWA_Sweetener_T_Deal',
  'FWA_Sweetener_C_Deal_P',
  'FWA_Sweetener_C_Deal',
];
export const PRO_REC_T = 'pro_rec_t';
export const PRO_C = 'pro_c';
export const PRO_MAN_T = 'pro_man_t';
